// Name einer Smart View mit Emoji (Agent 5A, Runde 5), rein und ohne React. Close speichert das Emoji als Anfang des Namens
// („📅 Simon · Follow-UP“); der Editor trennt es zum Bearbeiten und setzt es beim Speichern wieder davor.

const ANFANG = /^(\p{Extended_Pictographic}(?:️|‍\p{Extended_Pictographic}|[\u{1F3FB}-\u{1F3FF}])*️?)\s*(.*)$/su;

export function namenTeilen(name: string): { emoji: string; text: string } {
  const m = ANFANG.exec(name.trim());
  return m ? { emoji: m[1], text: m[2].trim() } : { emoji: "", text: name.trim() };
}

export function namenBauen(emoji: string, text: string): string {
  const t = text.replace(/\s+/g, " ").trim();
  const e = emoji.trim();
  return e ? (t ? `${e} ${t}` : e) : t;
}

/** Auswahl für die Emoji-Wahl: was in den Smart Views des Teams vorkommt, dazu gängige Zeichen für Listen. */
export const EMOJI_AUSWAHL = [
  "📅", "📞", "☎️", "🔁", "🔴", "🟠", "🟡", "🟢", "🔵", "⚪", "⚠️", "🚨", "✅", "❌", "🚫", "⭐", "🥇", "🥈", "🥉", "👀",
  "👤", "👥", "📧", "💬", "📝", "🔥", "💡", "🏢", "🏗️", "🔧", "📈", "📉", "🎯", "🕐", "📍", "🗓️", "❗", "❓", "💰", "🤝",
  "📊", "🔍", "🧾", "📌", "🔔", "🏷️", "📋", "🗂️",
];
